import React from 'react';
export const Header = () => {
  return <header className="text-center mb-12 mt-[50px]" data-id="element-20">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4" data-id="element-21">
        <span className="text-[4rem] md:text-[5rem] lg:text-[6rem] block mb-2" data-id="element-22">
          5
        </span>
        Reasons This Subscription-Free Smart Ring Sold Out in a Week
      </h1>
    </header>;
};